// extracted by mini-css-extract-plugin
export default {"content":"styles_content__Tp722","body":"styles_body__CAER1","trns":"styles_trns__vg+t4"};